<div class="bank-account-container">
    <section>
    <h4>Bank Accounts</h4>
    <br>
    <div *ngIf="!this.isMobile && this.bankAccounts.length > 0">
        <p-table [value]="bankAccounts" class="bank-accounts-table">
            <ng-template pTemplate="header">
                <thead class="table__table-header">
                    <th class="indent-0 w-1/5">
                        <p class="text-white">Bank</p>
                    </th>
                    <th class="indent-0 w-1/5">
                        <p class="text-white">Account Name</p>
                    </th>
                    <th class="indent-0 w-1/4">
                        <p class="text-white">Account Number</p>
                    </th>
                    <th class="indent-0 w-1/5">
                        <p class="text-white">Investor</p>
                    </th>
                    <th class="w-[15%]"></th>
                </thead>
            </ng-template>
            <ng-template pTemplate="body" let-bankAccount >
                <tr class="flex table-row-border">
                    <td class="flex items-center w-1/5">
                        <div class="text-wrap overflow-hidden break-words ">
                            <p>{{bankAccount.bankName}}</p>
                        </div>
                    </td>
                    <td class="flex items-center w-1/5">
                        <div class="text-wrap overflow-hidden break-words">
                            <p>{{bankAccount.bankAccountName}}</p>
                        </div>
                    </td>
                    <td class="flex items-center w-1/4">
                        <div class="text-wrap overflow-hidden break-words">
                            <p>{{bankAccount.bankAccountNumber}}</p>
                        </div>
                    </td>
                    <td class="flex items-center w-1/5">
                        <div class="text-wrap overflow-hidden break-words">
                            <p>{{bankAccount.investorEntityName}}</p>
                        </div>
                    </td>
                    <td class="flex items-center justify-end w-[15%]">
                        <div class="text-wrap text-right overflow-hidden break-words">
                            <a (click)="openBankAccountDialog(bankAccount)" class="a-text-button">
                                {{getCallToAction(bankAccount)}}
                            </a>
                            <small *ngIf="showOutstandingApprovalsText(bankAccount)">
                                ({{bankAccount.approvalsOutstanding}} approval(s) outstanding)
                            </small>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>

        </div>

        <div *ngIf="isMobile && bankAccounts.length > 0">
            <div *ngFor="let bankAccount of bankAccounts; last as isLast" class="block">
                <p><span class="font-semibold">Investor:</span> {{bankAccount.investorEntityName}}</p>
                <p><span class="font-semibold">Bank:</span> {{bankAccount.bankName}}</p>
                <p><span class="font-semibold">Account name:</span> {{bankAccount.bankAccountName}}</p>
                <p><span class="font-semibold">Account number:</span> {{bankAccount.bankAccountNumber}}</p>
                <p>
                    <span (click)="openBankAccountDialog(bankAccount)" class="cursor-pointer font-semibold underline view-link">{{getCallToAction(bankAccount)}}</span>
                    <small *ngIf="showOutstandingApprovalsText(bankAccount)"> ({{bankAccount.approvalsOutstanding}} approval(s) outstanding)</small>
                </p>
                <hr *ngIf="!isLast">
            </div>
        </div>

        <div *ngIf="this.bankAccounts.length === 0">
            <p><i>You do not have any bank accounts.</i></p>
        </div>
    </section>
</div>